module.exports = __webpack_public_path__ + "img/cart.24b33b27.svg";